import { render, staticRenderFns } from "./uploadResults.vue?vue&type=template&id=1958f56f&scoped=true&"
import script from "./uploadResults.vue?vue&type=script&lang=js&"
export * from "./uploadResults.vue?vue&type=script&lang=js&"
import style0 from "./uploadResults.vue?vue&type=style&index=0&id=1958f56f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958f56f",
  null
  
)

component.options.__file = "uploadResults.vue"
export default component.exports